// extracted by mini-css-extract-plugin
export default {"cls1":"RIQuestion-cls1_sSB","cls2":"RIQuestion-cls2_D8i RIQuestion-cls1_sSB"};